
import { Vue } from "vue-class-component";

export default class Clipboard extends Vue {}
